import styled from 'styled-components';

import { BODY_TEXT_SECONDARY } from 'styles/color';
import { FONT_WEIGHT_REGULAR } from 'styles/tokens';
import { LINE_HEIGHT_DEFAULT } from 'styles/typography';

import Text from './Text';

const SecondaryText = styled(Text)`
  color: ${BODY_TEXT_SECONDARY};
  font-weight: ${FONT_WEIGHT_REGULAR};
`;

export const SecondaryMultiLineText = styled(SecondaryText)`
  line-height: ${LINE_HEIGHT_DEFAULT};
  overflow: visible;
  overflow-wrap: break-word;
  text-align: left;
  white-space: pre-line;
`;

export default SecondaryText;
